/**
 * withSSRContext is DEPRECATED in AWS Amplify v6
 * 
 * For Next.js SSR with Amplify v6, use:
 * - @aws-amplify/adapter-nextjs with runWithAmplifyServerContext
 * 
 * This compatibility shim is provided for backward compatibility only.
 * It returns the Amplify instance but does not provide true SSR context isolation.
 * 
 * Migration guide: See MIGRATION_V5_TO_V6.md
 */
import { Amplify } from 'aws-amplify';
/**
 * @deprecated Use @aws-amplify/adapter-nextjs with runWithAmplifyServerContext for Next.js SSR
 * @param context SSR context (deprecated, not used in v6)
 * @returns Amplify instance
 */
export function withSSRContext(context) {
    if (context === void 0) { context = {}; }
    console.warn('withSSRContext is deprecated in AWS Amplify v6. ' +
        'For SSR support, use @aws-amplify/adapter-nextjs. ' +
        'See MIGRATION_V5_TO_V6.md for migration guide.');
    // Return the global Amplify instance
    // Note: This does NOT provide context isolation like v5 did
    return Amplify;
}
//# sourceMappingURL=withSSRContext.js.map